import BaseDropdown from './BaseDropdown';
import Dropdown from './Dropdown';

export default () => ({
    BaseDropdown,
    Dropdown
});
